<template>
	<tooltip v-if="color && color.name" position="top" :tip="label + ': ' + color.name">
		<img :src="image" :alt="label + ': ' + color.name" />
	</tooltip>
</template>

<script>
	export default {
		props: ['color', 'label'],
		computed: {
			image() {
				if(!this.color || !this.color.image) {
					return '';
				}
				return this.color.image.thumb100;
			}
		}
	}
</script>